module.exports = __webpack_public_path__ + "static/assets/60c7cb13fa42e621eaa9dba9ab94dc47.png";